const types = {
    UPDATE_FAILED: "AUTOACCEPT_DELIVERY_SLIP/UPDATE_FAILED",
    UPDATE_REQUEST: "AUTOACCEPT_DELIVERY_SLIP/UPDATE_REQUEST",
    UPDATE_SUCCESS: "AUTOACCEPT_DELIVERY_SLIP/UPDATE_SUCCESS",
};

export default types;
